import { Box } from '@mui/material';

function NRAITag({ height = '24', width = '24', color = 'currentColor', sx }) {
  return (
    <Box component="svg" width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24" fill="none" sx={{ ...sx }}>
      <path
        d="M20 22H4C2.96435 22 2.113 21.2128 2.01074 20.2041L2 20V4C2 2.89543 2.89543 2 4 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H4V20H20V13C20 12.4477 20.4477 12 21 12C21.5523 12 22 12.4477 22 13V20L21.9893 20.2041C21.8938 21.1457 21.1457 21.8938 20.2041 21.9893L20 22Z"
        fill={color}
      />
      <path
        d="M22.8602 5.79374L20.5061 4.76499C19.9369 4.51748 19.4836 4.06111 19.2363 3.49388L18.2086 1.1373C18.1288 0.954235 17.8712 0.954235 17.7913 1.1373L16.7636 3.49388C16.5164 4.06369 16.0605 4.51748 15.4938 4.76499L13.1372 5.79374C12.9543 5.87367 12.9543 6.1315 13.1372 6.21143L15.5351 7.2737C16.1017 7.5238 16.555 7.98273 16.7997 8.55255L17.7939 10.8627C17.8738 11.0458 18.134 11.0458 18.2138 10.8627L19.2389 8.5113C19.4862 7.94148 19.9421 7.4877 20.5087 7.24018L22.8628 6.21143C23.0457 6.1315 23.0457 5.87367 22.8628 5.79374H22.8602Z"
        fill={color}
      />
      <path
        d="M16.1162 11.4492C16.6097 11.4492 17.0098 11.8493 17.0098 12.3428V17H15.2227V12.3428C15.2227 11.8493 15.6227 11.4492 16.1162 11.4492Z"
        fill={color}
      />
      <path
        d="M12.3223 17L11.7012 14.9609H8.57812L7.95703 17H6L9.02344 8.39844H11.2441L14.2793 17H12.3223ZM11.2676 13.4375L10.6465 11.4453C10.6074 11.3125 10.5547 11.1426 10.4883 10.9355C10.4258 10.7246 10.3613 10.5117 10.2949 10.2969C10.2324 10.0781 10.1816 9.88867 10.1426 9.72852C10.1035 9.88867 10.0488 10.0879 9.97852 10.3262C9.91211 10.5605 9.84766 10.7832 9.78516 10.9941C9.72266 11.2051 9.67773 11.3555 9.65039 11.4453L9.03516 13.4375H11.2676Z"
        fill={color}
      />
    </Box>
  );
}
export default NRAITag;
